import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * PlanB forms
   */
  {
    // 1
    field: 'planBSexual',
    label: 'When was your last unprotected sexual encounter?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less24hrs', value: 'less than 24 hours' },
        { key: 'less72hrs', value: 'less than 72 hours' },
        { key: 'less5days', value: 'less than 5 days' },
        { key: '57days', value: '5 - 7 days' },
        { key: 'more7days', value: 'more than 7 days' },
        { key: 'orderProactively', value: 'I want to order proactively' }
      ]
    }
  },
  {
    // 2
    field: 'planBMenstrual',
    label: 'Last menstrual cycle?',
    type: 'info',
    answer: {
      type: 'date',
      required: true,
      name: 'lastMenstrual'
    }
  },
  {
    // 3
    field: 'planBIrregular',
    label: 'Do you have a history of irregular periods?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'planBIrregularYes', value: 'Yes' },
        { key: 'planBIrregularNo', value: 'No' }
      ]
    }
  },
  {
    // 4
    field: 'planBBC',
    label: 'Do you currently have a prescription for birth control?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'planBBCYes', value: 'Yes' },
        { key: 'planBBCNo', value: 'No' }
      ]
    }
  },
  {
    // 5
    field: 'planBBmi',
    label: 'BMI',
    type: 'info',
    answer: {
      type: 'bmi',
      showLabel: false,
      bmiLabel: 'BMI',
      showHeight: false,
      showWeight: false
    }
  },
  {
    // 6
    field: 'planBTablets',
    label: 'Do you use Birth control tablets, ring or patch?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'planBTabletsYes', value: 'Yes' },
        { key: 'planBTabletsNo', value: 'No' }
      ]
    }
  },
  {
    // 7
    field: 'planBMissTablet',
    label: 'How often do you miss a tablet/ring/patch?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'planBMissTabletOften', value: 'Often at least once a week' },
        {
          key: 'planBMissTabletSometimes',
          value: 'Sometimes, one or two times per month'
        },
        {
          key: 'planBMissTabletNotOften',
          value: 'Not often once a month or less'
        },
        {
          key: 'planBMissTabletRarely',
          value: 'Rarely, less than once a month'
        }
      ]
    }
  },
  {
    // 8
    field: 'planBContraception',
    label:
      'When you miss one or more tablets/ring/patch days do you use backup contraception?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'planBContraceptionYes', value: 'Yes' },
        {
          key: 'planBContraceptionSometimes',
          value: 'Sometimes, if I have it on hand'
        },
        {
          key: 'planBContraceptionNo',
          value: 'No'
        }
      ]
    }
  },
  {
    // 9
    field: 'planBAcknowledgement',
    label:
      'By selecting "I Acknowledge", you acknowledge that the society of Obstetricians and Gynaecologists of Canada have clarified that levonorgestrel-only emergency contraceptive pills (i..e plan B, contingency one and other generics) may be less effective in women with a body mass index (BMI) of 25–29 and potentially ineffective in women with a BMI ≥30. However, women with a BMI ≥30 who do not have access to or do not want a copper intrauterine device (IUD) for emergency contraception should not be discouraged from using levonorgestrel-only emergency contraception, since it may still provide some benefit. The medical team member reviewing my file will help determine if PlanB contingency one or other generics is right for me, or if another option will be more suitable.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'planBAcknowledgement', value: 'I Acknowledge' }]
    }
  }
];

export default questionsModels;
